import * as React from 'react';

import './Alert.scss';

export default function Alert(props: IAlertProps) {
  switch (props.type) {
    default:
    case 'info':
      const closeAction = props.onCloseAction
        ? props.onCloseAction
        : () => {
            return '';
          };
      return (
        <div className="account-switch-alert roboto">
          <div className="account-switch-alert-text">
            <i className="rpds-error info" />
            <p className="content">{props.children}</p>
          </div>
          <i className="rpds-close" onClick={closeAction} />
        </div>
      );
  }
}

interface IAlertProps {
  styleClass?: string;
  type?: string;
  text?: string;
  action?: any;
  onCloseAction?: any;
  children?: any;
}
